module.exports = __webpack_public_path__ + "img/laurent.f2da55c1.png";